export default "/assets/images/mama-small.e5e15457f821371a.png";